/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ShipmentPickupBookingMethod {
  Automatic = "Automatic",
  Email = "Email",
  Manual = "Manual",
}

export function instanceOfShipmentPickupBookingMethod(value: any): boolean {
  for (const key in ShipmentPickupBookingMethod) {
    if (
      Object.prototype.hasOwnProperty.call(ShipmentPickupBookingMethod, key)
    ) {
      if (
        ShipmentPickupBookingMethod[
          key as keyof typeof ShipmentPickupBookingMethod
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ShipmentPickupBookingMethodFromJSON(
  json: any,
): ShipmentPickupBookingMethod {
  return ShipmentPickupBookingMethodFromJSONTyped(json, false);
}

export function ShipmentPickupBookingMethodFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentPickupBookingMethod {
  return json as ShipmentPickupBookingMethod;
}

export function ShipmentPickupBookingMethodToJSON(
  value?: ShipmentPickupBookingMethod | null,
): any {
  return value as any;
}

export function ShipmentPickupBookingMethodToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShipmentPickupBookingMethod {
  return value as ShipmentPickupBookingMethod;
}
